import React from 'react';

export default function Penilaian() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Penilaian</h1>
      <p className="text-gray-500">Halaman Penilaian</p>
    </div>
  );
}
